import React from 'react';
import '../../App.css';
import AboutSection from '../AboutSection';

function AboutMe() {
  return (
    <div id="aboutMe">
      <AboutSection />
    </div>
  );
}

export default AboutMe;
